import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

@Component({
  name: 'TkFile',
  components: {},
})
class TkFile extends Vue {
  // #region [ PROPS ]
  @Prop({ default: '' })
  private readonly name: string;

  @Prop({ default: 'folder' })
  private readonly type: string;
  // #endregion

  // #region [ EVENTS ]
  @Emit('click')
  private emitClick() {}
  // #endregion

  // #region [ DATA ]
  private hover = false;
  // #endregion

  // #region [ COMPUTED ]
  private get icon(): string {
    const typeIconRelation: any = {
      folder: 'mdi-folder',
    };

    const hoverIconRelation: any = {
      folder: 'mdi-folder-open',
    };

    const hoverIcon = hoverIconRelation[this.type];
    const notHoverIcon = typeIconRelation[this.type];

    const icon = this.hover ?
      (hoverIcon || notHoverIcon) :
      notHoverIcon;

    return icon;
  }

  private get cardStyle() {
    const backgroundColor = this.hover ?
      '#EBF0FF' :
      undefined;

    const style = {
      backgroundColor,
    };

    return style;
  }
  // #endregion

  // #region [ METHODS ]
  private cardOnClick() {
    this.emitClick();
  }
  // #endregion
}

export default TkFile;